import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, Space, Radio, Card, Input, Select, Checkbox, message } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { InboxOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
const { Title, Paragraph, Text, Link } = Typography;
const { TextArea } = Input;
const AdminTagModal = (props) => {
    const [messageApi, contextHolder] = message.useMessage();
    const ref = useRef(0);
    return (
        <>
            {contextHolder}
            <Modal
                // width={'auto'}
                style={{ pointerEvents: 'auto' }}
                open={props.open}
                onOk={props.handleOk}
                bodyStyle={{ backgroundColor: props.edit ? '#faf6f5' : '##FCF5F6' }}
                width={400}
                footer={false}
                data={props.data}
                title={props.title}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: props.edit ? '#faf6f5' : '#FCF5F6', padding: '20px', borderTop: `solid #${props.color} 5px ` }}>
                        <Row gutter={[10, 10]} >
                            <Col span={24}>
                                <Row justify="space-between" align={'bottom'}>
                                    {props.edit ?
                                        <>
                                            <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/edit.png'></img>
                                        </> :
                                        <>
                                            <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/add.png'></img>
                                        </>}
                                    <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 45, left: 25 }} >{props.title}</Col>
                                    <Col>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[8, 8]} align={'middle'}>
                                    <Col span={6}>標籤名稱</Col>
                                    <Col span={18}>
                                        <Input placeholder={'請輸入標籤名稱'} type='text' value={props.editcard.tag_name} name="name" onChange={e => props.setEditCard(pre => ({ ...pre, tag_name: e.target.value }))} autoComplete='off' />
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => props.setOpen(false)} block>取消</Button>
                                    </Col>
                                    <Col >
                                        <Button
                                            onClick={e => { props.edit ? props.handleEdit() : props.handleSubmit() }}
                                            size='large' style={{ background: props.edit ? `#${props.color}` : 'rgba(232, 79, 117, 1)', color: '#ffffff' }} block>{props.edit ? '修改' : '送出'}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div >
                </>}
                centered
            >
            </Modal >
        </>
    )

}
export default AdminTagModal;